import React from 'react';
import TopRouteItem from '../TopRouteItem/TopRouteItem';
import '../../../../styles/TopRoutes.css';
import PropTypes from 'prop-types';

const TopRoutes = ({ data }) => {
  return (
    <div className="rlTopRoute">
      <div className="wrapper">
        <div className="rlTopRoute__content">
          {data && data.length > 0 && data.map((item) => <TopRouteItem key={item.id} data={item} />)}
        </div>
      </div>
    </div>
  );
};

TopRoutes.propTypes = {
  data: PropTypes.array
};

export default TopRoutes;
